import { Navigate, Route, Routes } from 'react-router-dom'
import DocumentDevicesPage from './DocumentDevicesPage'

export default function DocumentDevicesRoutes() {
    return (
        <Routes>
            <Route index element={<DocumentDevicesPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
